/* LavaLab – consenso recesso (art. 59 Cod. Consumo), dati fattura, imposta di bollo, funzione di recesso (art. 54-bis) */
(function () {
  'use strict';
  var C = window.LavaLab || {};
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var KEY = 'Consenso recesso';
  var KEY_TS = 'Consenso recesso - data e ora';
  var K_CF = 'Fattura - Codice fiscale o P.IVA';
  var K_SDI = 'Fattura - Codice SDI o PEC';
  var VAL = 'SI - Richiesta di esecuzione immediata e presa d’atto della perdita del diritto di recesso (art. 59, c. 1, lett. a e o, D.Lgs. 206/2005)';
  var state = { consent: !!C.consent, cf: C.cf || '', sdi: C.sdi || '', busy: false };

  function req(url, body) {
    return fetch(root + url, {
      method: body ? 'POST' : 'GET',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: body ? JSON.stringify(body) : undefined,
      credentials: 'same-origin'
    }).then(function (r) { return r.json(); });
  }
  function getCart() { return req('cart.js'); }
  function setAttrs(a) { return req('cart/update.js', { attributes: a }); }
  function saveConsent(on) {
    var a = {};
    a[KEY] = on ? VAL : '';
    a[KEY_TS] = on ? new Date().toISOString() : '';
    return setAttrs(a);
  }
  function saveBilling() {
    var a = {};
    a[K_CF] = state.cf;
    a[K_SDI] = state.sdi;
    return setAttrs(a);
  }
  function cleanCf(v) { return (v || '').replace(/\s+/g, '').toUpperCase(); }
  function validCf(v) {
    v = cleanCf(v);
    return /^[A-Z]{6}[0-9LMNPQRSTUV]{2}[A-Z][0-9LMNPQRSTUV]{2}[A-Z][0-9LMNPQRSTUV]{3}[A-Z]$/.test(v) || /^(IT)?[0-9]{11}$/.test(v);
  }
  function bolloInfo(cart) {
    var id = C.bolloVariantId, line = null, total = cart.total_price;
    (cart.items || []).forEach(function (it) { if (id && it.variant_id === id) line = it; });
    if (line) total -= line.final_line_price;
    return { line: line, need: !!id && total > (C.threshold || 7747) };
  }
  function syncBollo(cart) {
    if (!C.bolloVariantId) return Promise.resolve(false);
    return (cart ? Promise.resolve(cart) : getCart()).then(function (c) {
      var b = bolloInfo(c);
      if (b.need && !b.line) {
        return req('cart/add.js', { items: [{ id: C.bolloVariantId, quantity: 1 }] }).then(function () { return true; });
      }
      if (b.line && (!b.need || b.line.quantity !== 1)) {
        return req('cart/change.js', { id: b.line.key, quantity: b.need ? 1 : 0 }).then(function () { return true; });
      }
      return false;
    });
  }

  var noticeTimer;
  function refreshNotice() {
    clearTimeout(noticeTimer);
    noticeTimer = setTimeout(function () {
      getCart().then(function (c) {
        var b = bolloInfo(c);
        document.querySelectorAll('.ll-guard__bollo').forEach(function (n) {
          n.hidden = !b.need;
          var s = n.querySelector('[data-ll-bollo-text]');
          if (s) s.textContent = b.line ? (C.t && C.t.bolloIncluded) || '' : (C.t && C.t.bolloAdded) || '';
        });
      }).catch(function () {});
    }, 250);
  }
  function fillGuard(node) {
    var c = node.querySelector('.ll-consent-input');
    if (c) c.checked = state.consent;
    var f = node.querySelector('[data-ll-cf]');
    if (f) f.value = state.cf;
    var s = node.querySelector('[data-ll-sdi]');
    if (s) s.value = state.sdi;
  }
  function ensureGuards() {
    var t = document.getElementById('ll-guard-tpl');
    if (!t || !t.content) return;
    var added = false;
    document.querySelectorAll('.cart__ctas').forEach(function (el) {
      var prev = el.previousElementSibling;
      if (prev && prev.classList.contains('ll-guard')) return;
      var node = t.content.firstElementChild.cloneNode(true);
      fillGuard(node);
      el.parentNode.insertBefore(node, el);
      added = true;
    });
    if (added) refreshNotice();
  }
  function setError(kind) {
    document.querySelectorAll('.ll-guard').forEach(function (g) {
      g.classList.toggle('is-error', kind === 'consent');
      g.classList.toggle('is-error-cf', kind === 'cf');
    });
  }
  function showError(kind) {
    ensureGuards();
    setError(kind);
    var guards = document.querySelectorAll('.ll-guard');
    var visible = Array.prototype.find.call(guards, function (g) { return g.offsetParent !== null; });
    if (visible) {
      visible.scrollIntoView({ block: 'center', behavior: 'smooth' });
      if (kind === 'cf') { var i = visible.querySelector('[data-ll-cf]'); if (i) i.focus({ preventScroll: true }); }
    }
  }

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    if (t.closest('.ll-consent-input')) {
      state.consent = t.checked;
      document.querySelectorAll('.ll-consent-input').forEach(function (o) { o.checked = state.consent; });
      setError(null);
      saveConsent(state.consent).catch(function () {});
    } else if (t.matches('[data-ll-cf], [data-ll-sdi]')) {
      if (t.matches('[data-ll-cf]')) { state.cf = cleanCf(t.value); t.value = state.cf; }
      else { state.sdi = (t.value || '').trim(); }
      document.querySelectorAll('[data-ll-cf]').forEach(function (o) { if (o !== t) o.value = state.cf; });
      document.querySelectorAll('[data-ll-sdi]').forEach(function (o) { if (o !== t) o.value = state.sdi; });
      if (validCf(state.cf)) setError(null);
      saveBilling().catch(function () {});
    }
  });
  document.addEventListener('input', function (e) {
    var t = e.target;
    if (t && t.matches && t.matches('[data-ll-cf]')) state.cf = cleanCf(t.value);
    if (t && t.matches && t.matches('[data-ll-sdi]')) state.sdi = (t.value || '').trim();
  });

  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('button[name="checkout"], input[name="checkout"], a[href$="/checkout"]') : null;
    if (!btn) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    if (!validCf(state.cf)) { showError('cf'); return; }
    if (!state.consent) { showError('consent'); return; }
    if (state.busy) return;
    state.busy = true;
    btn.setAttribute('aria-busy', 'true');
    var a = {};
    a[KEY] = VAL; a[KEY_TS] = new Date().toISOString(); a[K_CF] = cleanCf(state.cf); a[K_SDI] = state.sdi;
    setAttrs(a)
      .then(function () { return syncBollo(); })
      .catch(function () {})
      .then(function () { window.location.href = root + 'checkout'; });
  }, true);

  var obsTimer;
  var observer = new MutationObserver(function () {
    clearTimeout(obsTimer);
    obsTimer = setTimeout(ensureGuards, 120);
  });

  function onCartPage() {
    var main = document.querySelector('main[data-template]');
    if (!main || main.getAttribute('data-template').indexOf('cart') !== 0) return;
    var n = 0;
    try { n = parseInt(sessionStorage.getItem('llBolloReload') || '0', 10); } catch (e) {}
    syncBollo().then(function (changed) {
      if (changed && n < 2) {
        try { sessionStorage.setItem('llBolloReload', String(n + 1)); } catch (e) {}
        window.location.reload();
      } else {
        try { sessionStorage.removeItem('llBolloReload'); } catch (e) {}
      }
    }).catch(function () {});
  }

  /* Funzione di recesso (art. 54-bis Codice del Consumo) */
  function initWithdrawal() {
    var wd = document.querySelector('[data-ll-withdraw]');
    if (!wd) return;
    var start = wd.querySelector('[data-ll-wd-start]');
    var form = wd.querySelector('form');
    if (start) start.addEventListener('click', function () {
      wd.classList.add('is-open');
      var first = wd.querySelector('.ll-wd__fields input:not([type=hidden])');
      if (first) first.focus();
    });
    if (form && !wd.querySelector('[data-ll-wd-receipt]')) form.addEventListener('submit', function () {
      var f = new FormData(form);
      var g = function (k) { return (f.get('contact[' + k + ']') || '').toString().trim(); };
      var stamp = new Date().toLocaleString('it-IT', { dateStyle: 'long', timeStyle: 'medium' });
      var txt = 'Con la presente io sottoscritto/a ' + g('Nome e cognome') + ' notifico il recesso dal contratto di acquisto relativo a: ' + (g('Corso') || 'prodotto indicato nell’ordine') + ', ordine n. ' + g('Numero ordine') + (g('Data ordine') ? ' del ' + g('Data ordine') : '') + '.';
      var body = form.querySelector('[name="contact[body]"]');
      if (body) body.value = 'DICHIARAZIONE DI RECESSO (art. 54-bis D.Lgs. 206/2005)\n' + txt + '\nData e ora di invio: ' + stamp + '\nEmail per la conferma: ' + g('email');
      try { sessionStorage.setItem('llWithdraw', JSON.stringify({ txt: txt, stamp: stamp, email: g('email') })); } catch (e) {}
    });
    var rec = wd.querySelector('[data-ll-wd-receipt]');
    if (rec) {
      try {
        var d = JSON.parse(sessionStorage.getItem('llWithdraw') || 'null');
        if (d) {
          rec.querySelector('[data-txt]').textContent = d.txt;
          rec.querySelector('[data-stamp]').textContent = d.stamp;
          rec.querySelector('[data-email]').textContent = d.email;
        }
      } catch (e) {}
    }
  }

  function init() {
    ensureGuards();
    var target = document.body;
    observer.observe(target, { childList: true, subtree: true });
    onCartPage();
    initWithdrawal();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
